import React, { useState, useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

const COURSE_LEVEL_OPTIONS = [
  'في الجيب +A', 'سهلة و ممتعة', 'من امتع المواد اللي درستها', 'واضحه و ما تحتاج خصوصي',
  'تلحق تذاكرها قبل بأقل من اسبوع', 'نص و نص', 'على حسب دكتورك في المادة', 'شوي معقدة',
  'لازم لك مصادر شرح لها', 'يبغالك تذاكر قبل ب ١٠-١٤ ايام', 'السلايدات سهله و الاختبارت لك عليها',
  'مصادرها مشتته', 'اختار الدكتور قبل تختار الماده', 'تقدر تعديها بس شد حيلك لازم',
  'يبغالك اول باول / قبل باكثر من اسبوعين', 'مافيها شي واضح', 'الدكتور نفسه مو فاهم المنهج',
  'مالها مصدر معين', 'المادة سهله بس الاختبارات صعبه جدا', 'تذاكر سنه قبل و بعد صعبه'
];

const COURSE_OTHER_OPTIONS = [
  'مشروعها سهل', 'ممتعه و انت تذاكرها', 'ماده مهمه في مجالنا', 'تكاليفها بسيطة و مهمه دراسيا',
  'اختباراتها سهله و واضحه', 'كويزات شويه صعبة', 'تقدر تعديها باعمال السنه', 'تكاليف شوي كثيرة',
  'كلها نظري و كلام', 'لازم تذاكر من أكثر من مصدر', 'عديها وبس', 'تخلص مذاكرتها و ما تدري ايش ذاكرت',
  'اختار دكتورك قبل الماده', 'مصادرها مشتته', 'يبغالك اول باول', 'منسقها مريض', 'مالها مصادر',
  'تذاكر سنه قبل و بعد صعبه', 'أسئلته تعجيزية و معقده', 'المادة صعبه جدا'
];

const LECTURER_CATEGORIES = {
  explanation: [
    { text: "يشرح بشكل مبسط", color: "rgba(95, 204, 156, 1)" },
    { text: "شرح بأمثلة واقعية تقرب الفكرة", color: "rgba(95, 204, 156, 1)" },
    { text: "يسهل لك المادة", color: "rgba(95, 204, 156, 1)" },
    { text: "من أفضل الشروحات التي مرت علي", color: "rgba(95, 204, 156, 1)" },
    { text: "أسلوبه ممتع وشيق", color: "rgba(95, 204, 156, 1)" },
    { text: "شرحه واضح أحيانا وأحيانا لا", color: "rgba(241, 194, 103, 1)" },
    { text: "يعتمد كثير على السلايدات", color: "rgba(241, 194, 103, 1)" },
    { text: "تقدر تفهم إذا ركزت", color: "rgba(241, 194, 103, 1)" },
    { text: "يشرح باختصار لكن يجاوب على الأسئلة", color: "rgba(241, 194, 103, 1)" },
    { text: "شرحه عادي يمشي الحال", color: "rgba(241, 194, 103, 1)" },
    { text: "يقرأ من السلايد فقط", color: "rgba(250, 134, 134, 1)" },
    { text: "ما يعطي أمثلة كفاية", color: "rgba(250, 134, 134, 1)" },
    { text: "شرحه ممل شوي", color: "rgba(250, 134, 134, 1)" },
    { text: "تعتمد على نفسك أكثر من شرحه", color: "rgba(250, 134, 134, 1)" },
    { text: "ما يهتم إذا فهمنا أو لا", color: "rgba(250, 134, 134, 1)" },
    { text: "شرحه مشتت وغير مفهوم", color: "rgba(180, 35, 24, 1)" },
    { text: "محاضرة هواجيس", color: "rgba(180, 35, 24, 1)" },
    { text: "صعب جدا تتابعه أو تفهم منه", color: "rgba(180, 35, 24, 1)" },
    { text: "يشرح بمصطلحات غير مفهومة", color: "rgba(180, 35, 24, 1)" },
    { text: "شرح بريال", color: "rgba(180, 35, 24, 1)" }
  ],
  grades: [
    { text: "كويزات سهلة وواضحة", color: "rgba(95, 204, 156, 1)" },
    { text: "تكاليف بسيطة وتعليمية", color: "rgba(95, 204, 156, 1)" },
    { text: "يتعاون في التصحيح", color: "rgba(95, 204, 156, 1)" },
    { text: "يساعد بيونس محفز", color: "rgba(95, 204, 156, 1)" },
    { text: "ما يقصر أو يظلم أحد", color: "rgba(95, 204, 156, 1)" },
    { text: "لازم تذاكر من أكثر من مصدر", color: "rgba(241, 194, 103, 1)" },
    { text: "يطلب تكاليف شوي كثيرة", color: "rgba(241, 194, 103, 1)" },
    { text: "حقاني في الدرجات", color: "rgba(241, 194, 103, 1)" },
    { text: "كويزات شويه صعبة", color: "rgba(241, 194, 103, 1)" },
    { text: "ممكن يظلم في التصحيح", color: "rgba(241, 194, 103, 1)" },
    { text: "اختباراته غريبة وما تتكرر", color: "rgba(250, 134, 134, 1)" },
    { text: "يصحح بدقة زائدة", color: "rgba(250, 134, 134, 1)" },
    { text: "يعطي درجه نص حتى لو غلط بسيط", color: "rgba(250, 134, 134, 1)" },
    { text: "يكثر أسئلة بين السطور", color: "rgba(250, 134, 134, 1)" },
    { text: "تكاليفه كثيرة بدون هدف واضح", color: "rgba(250, 134, 134, 1)" },
    { text: "مستحيل تجيب درجة كاملة", color: "rgba(180, 35, 24, 1)" },
    { text: "أسئلته تعجيزية", color: "rgba(180, 35, 24, 1)" },
    { text: "ظلم في التصحيح", color: "rgba(180, 35, 24, 1)" },
    { text: "يعطى أقل من المتوقع دائما", color: "rgba(180, 35, 24, 1)" },
    { text: "طلباته فوق طاقتك", color: "rgba(180, 35, 24, 1)" }
  ],
  dealing: [
    { text: "صبور في الشرح والنقاش", color: "rgba(95, 204, 156, 1)" },
    { text: "مرح و يبغى يكسبكم", color: "rgba(95, 204, 156, 1)" },
    { text: "يرد بسرعة على الرسائل", color: "rgba(95, 204, 156, 1)" },
    { text: "يشجع و يسمع للطلاب ويتفهمهم", color: "rgba(95, 204, 156, 1)" },
    { text: "محترم جدا ويتعامل بذوق", color: "rgba(95, 204, 156, 1)" },
    { text: "يعطي وجه بس ما يساعد", color: "rgba(241, 194, 103, 1)" },
    { text: "يسمع بس ما يغير رأيه", color: "rgba(241, 194, 103, 1)" },
    { text: "ما يضحك كثير بس محترم", color: "rgba(241, 194, 103, 1)" },
    { text: "يرد على الرسائل متأخر", color: "rgba(241, 194, 103, 1)" },
    { text: "طلباته فوق طاقتك", color: "rgba(241, 194, 103, 1)" },
    { text: "يدقق على التفاهات", color: "rgba(250, 134, 134, 1)" },
    { text: "تعامله يختلف من طالب لطالب", color: "rgba(250, 134, 134, 1)" },
    { text: "يجاوب بجفاف", color: "rgba(250, 134, 134, 1)" },
    { text: "يحسس الطلاب إنهم يزعجونه", color: "rgba(250, 134, 134, 1)" },
    { text: "أحيانا يعصب بدون سبب", color: "rgba(250, 134, 134, 1)" },
    { text: "ما يستمع للطلاب", color: "rgba(180, 35, 24, 1)" },
    { text: "يصعب التواصل معه تماما", color: "rgba(180, 35, 24, 1)" },
    { text: "نرجسي مع الطلاب", color: "rgba(180, 35, 24, 1)" },
    { text: "يتكلم بطريقة غير لائقة", color: "rgba(180, 35, 24, 1)" },
    { text: "تعامل سيء جدا", color: "rgba(180, 35, 24, 1)" }
  ],
  preparation: [
    { text: "محاضرات منظمة ومنهجية", color: "rgba(95, 204, 156, 1)" },
    { text: "محتوى محدث ومفيد", color: "rgba(95, 204, 156, 1)" },
    { text: "أمثلة عملية وتطبيقية", color: "rgba(95, 204, 156, 1)" },
    { text: "مصادر إضافية مفيدة", color: "rgba(95, 204, 156, 1)" },
    { text: "تحضير جيد للمحاضرات", color: "rgba(95, 204, 156, 1)" },
    { text: "مادة علمية حديثة", color: "rgba(241, 194, 103, 1)" },
    { text: "أبحاث ودراسات حديثة", color: "rgba(241, 194, 103, 1)" },
    { text: "محتوى متوازن", color: "rgba(241, 194, 103, 1)" },
    { text: "أمثلة من الحياة العملية", color: "rgba(241, 194, 103, 1)" },
    { text: "مصادر متنوعة", color: "rgba(241, 194, 103, 1)" }
  ],
  other: [
    { text: "من قائمة الأفضل في الجامعة", color: "rgba(95, 204, 156, 1)" },
    { text: "الكل يمدحه", color: "rgba(95, 204, 156, 1)" },
    { text: "الله يسعده ويكثر من أمثاله", color: "rgba(95, 204, 156, 1)" },
    { text: "أسطورة بكل معنى الكلمة", color: "rgba(95, 204, 156, 1)" },
    { text: "تسجل عنده وانت مغمض", color: "rgba(95, 204, 156, 1)" },
    { text: "كويس بس مو مميز", color: "rgba(241, 194, 103, 1)" },
    { text: "يمشي الحال", color: "rgba(241, 194, 103, 1)" },
    { text: "فيه ناس تمدحه وناس لا", color: "rgba(241, 194, 103, 1)" },
    { text: "يعتمد على مزاجه", color: "rgba(241, 194, 103, 1)" },
    { text: "جيد أكاديميا بس ممل شوي", color: "rgba(241, 194, 103, 1)" },
    { text: "مو مرة أنصح فيه", color: "rgba(250, 134, 134, 1)" },
    { text: "أغلب الطلاب ما ارتاحوا", color: "rgba(250, 134, 134, 1)" },
    { text: "المادة معه أثقل من غيره", color: "rgba(250, 134, 134, 1)" },
    { text: "تعامله يخليك تكره الماده", color: "rgba(250, 134, 134, 1)" },
    { text: "فيه ظلم أحيانا", color: "rgba(250, 134, 134, 1)" },
    { text: "اسوا تجربة", color: "rgba(180, 35, 24, 1)" },
    { text: "المادة سهله معه صعبه", color: "rgba(180, 134, 24, 1)" },
    { text: "لا يشرح ولا يتجاوب", color: "rgba(180, 35, 24, 1)" },
    { text: "أغلب الطلاب يحذرون منه", color: "rgba(180, 35, 24, 1)" },
    { text: "ما يستمع للطلاب", color: "rgba(180, 35, 24, 1)" }
  ]
};

const getCourseButtonStyles = (opt, isSelected) => {
  let borderColor = '#5FCC9C';
  let bgColor = '#2A9E8D';
  let shadowColor = 'rgba(162, 233, 189, 0.6)';

  if(opt.includes('صعبه') || opt.includes('معقدة') || opt.includes('مشتته') || opt.includes('مريض') || opt.includes('ما تدري') || opt.includes('تعجيزية')) {
      borderColor = '#FA8686'; bgColor = '#FA8686'; shadowColor = '#FA8686';
      if(opt.includes('مافيها شي') || opt.includes('مو فاهم') || opt.includes('مالها مصادر') || opt.includes('منسقها مريض') || opt.includes('تذاكر سنه') || opt.includes('المادة صعبه جدا')) {
         borderColor = '#B42318'; bgColor = '#B42318'; shadowColor = '#B42318';
      }
  } else if (opt.includes('نص و نص') || opt.includes('حسب') || opt.includes('لازم') || opt.includes('يبغالك') || opt.includes('شوي')) {
      borderColor = '#F2C266'; bgColor = '#F1C267'; shadowColor = '#F2C266';
  }

  return {
      padding: '4px 12px', width: '100%', height: '32px', borderRadius: '24px',
      fontFamily: 'Alexandria, sans-serif', fontSize: '14px', fontWeight: '300', lineHeight: '24px',
      border: '1px solid',
      borderColor: isSelected ? bgColor : borderColor,
      background: isSelected
          ? `radial-gradient(43.64% 77.08% at 50% -10.42%, ${bgColor}80 0%, ${bgColor}00 100%), ${bgColor}40`
          : 'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), #081423'
  };
};

const EvaluationModal = ({ isOpen, onClose, lecturerName, type = 'lecturer' }) => {
  const [currentStep, setCurrentStep] = useState(type === 'course' ? 2 : 1);

  const isLecturerMain = type === 'lecturer';
  const isCourseMain = type === 'course';

  const [selectedGrades, setSelectedGrades] = useState({
    explanation: null,
    dealing: null,
    grades: null,
    preparation: null,
  });

  const [selectedCategories, setSelectedCategories] = useState({
    explanation: [],
    dealing: [],
    grades: [],
    preparation: [],
    other: [],
  });

  const [selectedLevelOptions, setSelectedLevelOptions] = useState({});
  const [selectedOtherOptions, setSelectedOtherOptions] = useState({});

  const [finalGrade, setFinalGrade] = useState('');
  const [studyStatus, setStudyStatus] = useState(false);
  const [isDeleteClicked, setIsDeleteClicked] = useState(false);

  const [courseFinalGrade, setCourseFinalGrade] = useState('');
  const [courseStudyStatus, setCourseStudyStatus] = useState(false);
  const [courseIsDeleteClicked, setCourseIsDeleteClicked] = useState(false);

  const [subject, setSubject] = useState('');
  const [comment, setComment] = useState('');

  const [courseName, setCourseName] = useState('');
  const [courseCode, setCourseCode] = useState('');
  const [courseResults, setCourseResults] = useState([]);
  const [courseLoading, setCourseLoading] = useState(false);
  const courseSearchTimeoutRef = useRef(null);
  const [showCourseSuggestions, setShowCourseSuggestions] = useState(false);

  const [lecturerSearchQuery, setLecturerSearchQuery] = useState('');
  const [showLecturerSuggestions, setShowLecturerSuggestions] = useState(false);

  const [submitting, setSubmitting] = useState(false);
  const [submitMsg, setSubmitMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState('');
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    setSuccess(false);
    setSubmitting(false);
    setSubmitMsg('');
    setCurrentStep(type === 'course' ? 2 : 1);

    let cancelled = false;
    (async () => {
      try {
        const r = await fetch('/auth/me', { credentials: 'include' });
        const d = r.ok ? await r.json().catch(() => ({})) : {};
        if (!cancelled) setUserEmail(d?.user?.email || '');
      } finally {
        if (!cancelled) setAuthChecked(true);
      }
    })();
    return () => { cancelled = true; };
  }, [isOpen, type]);

  useEffect(() => {
    if (!isCourseMain) {
      setCourseResults([]);
      setCourseLoading(false);
      return;
    }
    const q = (courseName || '').trim();
    if (courseSearchTimeoutRef.current) clearTimeout(courseSearchTimeoutRef.current);

    if (!q || q.length < 2) {
      setCourseResults([]);
      setShowCourseSuggestions(false);
      return;
    }

    courseSearchTimeoutRef.current = setTimeout(async () => {
      try {
        setCourseLoading(true);
        const res = await fetch(`/api/courses-directory/search?q=${encodeURIComponent(q)}`, { credentials: 'include' });
        if (!res.ok) {
          setCourseResults([]); return;
        }
        const data = await res.json();
        setCourseResults(Array.isArray(data) ? data : []);
        setShowCourseSuggestions(true);
      } catch (err) {
        setCourseResults([]);
      } finally {
        setCourseLoading(false);
      }
    }, 350);

    return () => { if (courseSearchTimeoutRef.current) clearTimeout(courseSearchTimeoutRef.current); };
  }, [isCourseMain, courseName]);

  useEffect(() => {
    if (isOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.course-search-container')) setShowCourseSuggestions(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  const handleNext = () => {
    if (currentStep < 3) setCurrentStep((s) => s + 1);
  };

  const handlePrevious = () => {
    const minStep = type === 'course' ? 2 : 1;
    if (currentStep > minStep) setCurrentStep((s) => s - 1);
  };

  const handleCategorySelection = (category, option) => {
    setSelectedCategories((prev) => ({
      ...prev,
      [category]: prev[category].includes(option)
        ? prev[category].filter((item) => item !== option)
        : [...prev[category], option],
    }));
  };

  const handleGradeSelection = (category, grade) => {
    setSelectedGrades((prev) => ({
      ...prev,
      [category]: prev[category] === grade ? null : grade,
    }));
  };

  const handleFinalGradeSelection = (grade) => {
    setStudyStatus(false);
    setIsDeleteClicked(false);
    setFinalGrade((prev) => (prev === grade ? '' : grade));
  };
  const handleDeleteClick = () => {
    setFinalGrade('');
    setIsDeleteClicked((v) => !v);
    setStudyStatus(false);
  };
  const handleStudyStatusToggle = () => {
    setStudyStatus((prev) => {
      const next = !prev;
      if (next) { setFinalGrade(''); setIsDeleteClicked(false); }
      return next;
    });
  };

  const handleCourseFinalGradeSelection = (grade) => {
    setCourseFinalGrade((prev) => (prev === grade ? '' : grade));
    setCourseIsDeleteClicked(false);
    setCourseStudyStatus(false);
  };
  const handleCourseDeleteClick = () => {
    setCourseFinalGrade('');
    setCourseIsDeleteClicked((v) => !v);
    setCourseStudyStatus(false);
  };
  const handleCourseStudyStatusToggle = () => {
    setCourseStudyStatus((prev) => {
      const next = !prev;
      if (next) { setCourseFinalGrade(''); setCourseIsDeleteClicked(false); }
      return next;
    });
  };

  const handleLevelOptionSelection = (option) => {
    setSelectedLevelOptions((prev) => ({ ...prev, [option]: !prev[option] }));
  };
  const handleOtherOptionSelection = (option) => {
    setSelectedOtherOptions((prev) => ({ ...prev, [option]: !prev[option] }));
  };

  const handleCourseSelect = (course) => {
    setCourseName(course.name);
    setCourseCode(course.code);
    setShowCourseSuggestions(false);
  };

  const handleSubmit = async () => {
    if (!authChecked) return;
    if (!userEmail) { setSubmitMsg('لا يمكن إرسال التقييم بدون تسجيل الدخول أو بريد طالب.'); return; }
    if (submitting || success) return;

    if (isLecturerMain) {
        const REQUIRED_CATS = ['explanation', 'grades', 'dealing', 'preparation'];
        const missingCats = REQUIRED_CATS.filter((k) => !Number.isFinite(selectedGrades?.[k]));
        if (missingCats.length > 0) {
            setSubmitMsg('رجاءً اختر درجة لكل الفئات.');
            return;
        }
    }

    const trimmedDoctorName = isLecturerMain ? String(lecturerName || '').trim() : '';
    const trimmedCourseName = isCourseMain ? String(courseName || '').trim() : '';

    if (!trimmedDoctorName && !trimmedCourseName) { setSubmitMsg('يجب اختيار محاضر أو مقرر.'); return; }
    if (trimmedDoctorName && trimmedCourseName) { setSubmitMsg('لا ترسل اسمي المحاضر والمقرر معاً.'); return; }
    if (isLecturerMain && !trimmedDoctorName) { setSubmitMsg('اختر اسم المحاضر.'); return; }
    if (isCourseMain && !trimmedCourseName) { setSubmitMsg('اختر اسم المقرر.'); return; }

    let trimmedCourseCode = '';
    if (isCourseMain) {
        trimmedCourseCode = String(courseCode || '').trim();
        if (!trimmedCourseCode) { setSubmitMsg('كود المقرر مطلوب. اختر المقرر من القائمة.'); return; }
    }

    const effectiveStudyStatus = isCourseMain ? courseStudyStatus : studyStatus;
    const effectiveFinalGrade = isCourseMain ? courseFinalGrade : finalGrade;
    const isDelete = isCourseMain ? courseIsDeleteClicked : isDeleteClicked;

    if (!effectiveStudyStatus && !effectiveFinalGrade && !isDelete) {
        setSubmitMsg('رجاءً اختر الدرجة أو قيد الدراسة');
        return;
    }

    const finalChoice = effectiveStudyStatus ? 'قيد الدراسة' : effectiveFinalGrade || null;
    const toTextArray = (arr = []) => Array.isArray(arr) ? arr : [];

    let submissionTags = { ...selectedCategories };
    if (isCourseMain) {
        const levels = Object.keys(selectedLevelOptions).filter(k => selectedLevelOptions[k]);
        const others = Object.keys(selectedOtherOptions).filter(k => selectedOtherOptions[k]);
        submissionTags.other = [...levels, ...others];
    }

    const basePayload = {
      doctorname: trimmedDoctorName,
      coursename: trimmedCourseName,
      reviewtext: (comment || '').trim(),
      explanationrating: isLecturerMain ? selectedGrades?.explanation : null,
      interactionrating: isLecturerMain ? selectedGrades?.dealing : null,
      gradesrating: isLecturerMain ? selectedGrades?.grades : null,
      attendancerating: isLecturerMain ? selectedGrades?.preparation : null,
      explanationtags: toTextArray(submissionTags.explanation),
      gradetags: toTextArray(submissionTags.grades),
      attendancetags: toTextArray(submissionTags.preparation),
      othertags: toTextArray(submissionTags.other),
      finalgrade: finalChoice,
      studystatus: !!effectiveStudyStatus,
      studentemail: userEmail,
      page: typeof window !== 'undefined' ? window.location.pathname : null,
      pageTitle: typeof document !== 'undefined' ? document.title : null,
      referrer: typeof document !== 'undefined' ? document.referrer : null,
    };


    const payload = isCourseMain
      ? {
          ...basePayload,
          code: trimmedCourseCode,
          coursetags: toTextArray(submissionTags.other),
          tags: toTextArray(submissionTags.other),
        }
      : basePayload;

    try {
      setSubmitting(true);
      setSubmitMsg('');
      const res = await fetch('/api/reviews', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        const msg = err?.message || `HTTP ${res.status}`;
        if (msg === 'doctorname or coursename is required') setSubmitMsg('يجب اختيار محاضر أو مقرر.');
        else if (msg === 'studentemail is required') setSubmitMsg('البريد الجامعي مطلوب.');
        else if (msg === 'course_code_required') setSubmitMsg('كود المقرر مطلوب.');
        else if (msg === 'invalid_course_code') setSubmitMsg('كود المقرر غير صحيح.');
        else setSubmitMsg('حدث خطأ أثناء الإرسال ❌');
        throw new Error(msg);
      }

      setSuccess(true);
      setTimeout(() => { onClose(); }, 1500);
    } catch (e) {
      console.error('Submit error:', e);
      if (!submitMsg) setSubmitMsg('حدث خطأ أثناء الإرسال ❌');
    } finally {
      setSubmitting(false);
    }
  };

  const renderStep1 = () => (
    <div className="mb-6 md:mb-8 p-3 md:p-4 border border-[#28e3da40] rounded-xl"
         style={{ width: '100%', minHeight: '250px', padding: '12px', border: '1px solid rgba(40, 227, 218, 0.25)', borderRadius: '12px' }}>
      <h3 className="text-white font-medium text-lg md:text-xl text-right mb-4 md:mb-6">اختر التقييم لكل فئة</h3>
      {['explanation', 'dealing', 'grades', 'preparation'].map((category) => (
        <div key={category} className="space-y-2 mb-6 last:mb-0">
            <div className="flex flex-col gap-4 mb-6 last:mb-0 md:flex md:flex-row md:items-center md:justify-between md:gap-4">
                <div className="w-full flex justify-center md:hidden">
                    <span className="text-white text-xs md:text-sm font-medium text-center">
                        {category === 'explanation' ? 'الشرح' : category === 'grades' ? 'الدرجات' : category === 'preparation' ? 'التحضير' : 'التعامل'}
                    </span>
                </div>
                <div className="flex items-center justify-start flex-row-reverse flex-nowrap overflow-x-auto pe-2 gap-[5px] md:justify-center md:flex-wrap md:gap-4">
                    {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((grade, index) => {
                        const isSelected = selectedGrades[category] !== null && grade <= selectedGrades[category];
                        const getSelectedColor = (g) => {
                            if (g >= 80) return 'bg-[#A2E9BD]';
                            if (g >= 60) return 'bg-[#F2C266]';
                            if (g >= 30) return 'bg-[#FA8686]';
                            return 'bg-[#FF0000]';
                        };
                        return (
                            <div key={grade} className="flex flex-col items-center shrink-0">
                                <span className="text-white text-sm font-bold leading-6 md:text-sm md:leading-6">{grade}</span>
                                <button
                                    onClick={() => handleGradeSelection(category, grade)}
                                    className={`w-4 h-4 rounded-full md:w-16 md:h-6 transition-all duration-200 hover:scale-100 ${isSelected ? getSelectedColor(selectedGrades[category]) : 'bg-[#2a3a4a]'} ${index === 10 ? 'md:rounded-r-md' : index === 0 ? 'md:rounded-l-md' : 'md:rounded-none'}`}
                                />
                            </div>
                        );
                    })}
                </div>
                <div className="hidden md:flex md:w-24 md:items-center md:justify-center">
                    <span className="text-white text-xs md:text-sm font-medium text-center">
                        {category === 'explanation' ? 'الشرح' : category === 'grades' ? 'الدرجات' : category === 'preparation' ? 'التحضير' : 'التعامل'}
                    </span>
                </div>
            </div>
        </div>
      ))}
    </div>
  );

  const renderStep2 = () => {
    if (type === 'course') {
        return (
            <div>
                <h3 className="text-white font-medium text-lg md:text-xl text-right mb-4 md:mb-6">اختر طبيعة المادة</h3>

                <div className="mb-6 md:mb-8">
                    <h4 className="text-white font-medium text-sm text-right mb-4">المستوى</h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 justify-items-center" dir="rtl">
                        {COURSE_LEVEL_OPTIONS.map(opt => {
                            const isSelected = selectedLevelOptions[opt];
                            const styles = getCourseButtonStyles(opt, isSelected);
                            return (
                                <button key={opt} onClick={() => handleLevelOptionSelection(opt)} className="flex items-center justify-between transition-all duration-200 flex-row-reverse" style={styles}>
                                    <div className="border rounded-[10px]" style={{ width: '8px', height: '8px', backgroundColor: styles.borderColor, boxShadow: `0px 3px 20px ${styles.borderColor}` }}></div>
                                    <span className="text-white text-right text-[14px] sm:text-[10px]">{opt}</span>
                                </button>
                            )
                        })}
                    </div>
                </div>

                <div className="mb-6 md:mb-8">
                    <h4 className="text-white font-medium text-sm text-right mb-4">أخرى</h4>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 justify-items-center" dir="rtl">
                         {COURSE_OTHER_OPTIONS.map(opt => {
                            const isSelected = selectedOtherOptions[opt];
                            const styles = getCourseButtonStyles(opt, isSelected);
                            return (
                                <button key={opt} onClick={() => handleOtherOptionSelection(opt)} className="flex items-center justify-between transition-all duration-200 flex-row-reverse" style={styles}>
                                    <div className="border rounded-[10px]" style={{ width: '8px', height: '8px', backgroundColor: styles.borderColor }}></div>
                                    <span className="text-white text-right text-[14px] sm:text-[10px]">{opt}</span>
                                </button>
                            )
                        })}
                    </div>
                </div>
            </div>
        );
    } else {
        const cats = [
            { id: 'explanation', title: 'الشرح', items: LECTURER_CATEGORIES.explanation },
            { id: 'grades', title: 'الدرجات والاختبارات', items: LECTURER_CATEGORIES.grades },
            { id: 'dealing', title: 'التعامل', items: LECTURER_CATEGORIES.dealing },
            { id: 'preparation', title: 'التحضير', items: LECTURER_CATEGORIES.preparation },
            { id: 'other', title: 'أخرى', items: LECTURER_CATEGORIES.other }
        ];

        return (
            <div>
                <h3 className="text-white font-medium text-lg text-right mb-6">اختر الفئات التي تريد تقييمها</h3>
                <div className="p-4 border border-[#28e3da40] rounded-xl" style={{ border: '1px solid rgba(40, 227, 218, 0.25)', borderRadius: '12px' }}>
                    {cats.map(cat => (
                        <div key={cat.id} className="mb-6">
                            <h4 className="text-white font-medium text-sm text-right mb-4">{cat.title}</h4>
                            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-3 justify-items-center" dir="rtl">
                                {cat.items.map((option, idx) => (
                                    <button
                                        key={idx}
                                        onClick={() => handleCategorySelection(cat.id, option.text)}
                                        className="flex flex-row-reverse items-center justify-between p-1 px-3 rounded-3xl border transition-all duration-200 text-right"
                                        style={{
                                            width: '100%', height: '32px',
                                            background: selectedCategories[cat.id].includes(option.text)
                                                ? `radial-gradient(43.64% 77.08% at 50% -10.42%, ${option.color.replace('1)', '0.5)')} 0%, ${option.color.replace('1)', '0)')} 100%), ${option.color.replace('1)', '0.25)')}`
                                                : 'linear-gradient(0deg, rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)), #081423',
                                            border: `1px solid ${option.color}`,
                                            borderRadius: '24px'
                                        }}
                                    >
                                        <div className="w-2 h-2 rounded-full" style={{ background: option.color, boxShadow: '0px 3px 20px rgba(162, 233, 189, 0.6)' }}></div>
                                        <span className="text-white font-light text-right text-[14px] sm:text-[10px]">{option.text}</span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
  };

  const renderStep3 = () => {
    if (type === 'course') {
      return (
        <div>
          <div className="mb-6">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-3">
              <div className="text-right md:hidden mb-3">
                <h4 className="text-white font-medium text-base">الدرجة النهائية</h4>
                <p className="text-gray-400 text-sm">(إجباري: اختر درجة أو فعّل قيد الدراسة)</p>
              </div>
              <div className="flex flex-wrap gap-2 justify-between flex-1">
                {['F', 'D', 'D+', 'C', 'C+', 'B', 'B+', 'A', 'A+', 'حذف'].map((grade) => {
                    const selected = courseFinalGrade === grade && !courseStudyStatus;
                    const bg = grade === 'حذف'
                        ? (courseIsDeleteClicked && !courseStudyStatus ? 'rgba(227, 40, 90, 0.5)' : '#D5D2D2')
                        : (selected ? '#40E3DA' : '#D5D2D2');

                    return (
                        <button
                            key={grade} type="button" disabled={courseStudyStatus}
                            onClick={() => grade === 'حذف' ? handleCourseDeleteClick() : handleCourseFinalGradeSelection(grade)}
                            className="flex items-center justify-center transition-all duration-200 disabled:opacity-60"
                            style={{
                                flex: '1 1 0%', minWidth: '60px', height: '28px', borderRadius: '12px',
                                background: bg === '#40E3DA' ? 'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0.25) 100%)' : bg,
                                color: '#081423',
                                border: selected ? '0.5px solid rgba(40, 227, 218, 0.25)' : 'none'
                            }}
                        >
                            {grade}
                        </button>
                    );
                })}
              </div>
            </div>
          </div>

          <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-end gap-3">
            <div className="flex items-center justify-center md:justify-end gap-3">
              <div onClick={handleCourseStudyStatusToggle} className="relative cursor-pointer" style={{ width: '48px', height: '24px' }}>
                <div className="absolute inset-0 rounded-full" style={{ background: courseStudyStatus ? '#2A9E8D' : '#D5D2D2' }} />
                <div className={`absolute w-5 h-5 rounded-full shadow-md transition-all duration-200 ${courseStudyStatus ? 'translate-x-6' : 'left-0.5'}`} style={{ top: '2px', background: '#0f1e2e' }} />
              </div>
              <span className="text-white font-medium text-base">قيد الدراسة</span>
            </div>
          </div>

          <div className="mb-6 relative course-search-container">
            <div className="text-right mb-3">
                <h4 className="text-white font-medium text-base">المادة (ابحث واختر)</h4>
            </div>

            {courseCode ? (
                <div className="w-full p-3 bg-[#1a2a3a] border border-[#28e3da40] rounded-lg flex justify-end">
                    <button
                        onClick={() => { setCourseName(''); setCourseCode(''); }}
                        className="bg-white text-[#081423] px-4 py-1 rounded-2xl text-sm font-bold flex items-center gap-2 hover:bg-gray-200 transition-colors"
                    >
                        ✕ {courseName}
                    </button>
                </div>
            ) : (
                <div className="relative" dir="rtl">
                    <input
                        type="text"
                        value={courseName}
                        onChange={(e) => { setCourseName(e.target.value); setCourseCode(''); }}
                        placeholder="ابحث عن اسم المقرر أو الرمز..."
                        className="w-full p-3 bg-[#1a2a3a] border border-[#28e3da40] rounded-lg text-white text-right focus:outline-none focus:border-[#28e3da]"
                    />
                    {courseLoading && <div className="absolute left-3 top-3 text-gray-400 text-xs">جاري البحث...</div>}

                    {showCourseSuggestions && courseResults.length > 0 && (
                        <div className="absolute z-50 w-full bg-[#1a2a3a] border border-[#28e3da40] rounded-lg mt-1 max-h-48 overflow-y-auto shadow-lg">
                            {courseResults.map((course) => (
                                <div
                                  key={course.code || course.id || course.name}
                                  onClick={() => handleCourseSelect(course)}
                                  className="p-2 hover:bg-[#2a3a4a] cursor-pointer text-white text-right border-b border-gray-700 last:border-0"
                                >
                                    <div className="font-bold">{course.name}</div>
                                    <div className="text-xs text-gray-400">{course.code} - {course.college}</div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            )}
          </div>

          <div className="mb-6">
            <div className="text-right mb-3"><h4 className="text-white font-medium text-base">تعليق مقرر</h4></div>
            <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="اكتب تعليقك هنا..." rows={6} maxLength={500} className="w-full p-3 bg-[#1a2a3a] border border-[#28e3da40] rounded-lg text-white text-right resize-none" dir="rtl" />
            <p className="text-gray-400 text-sm text-right mt-2">الباقي: {500 - comment.length}</p>
          </div>
        </div>
      );
    }

    return (
        <div>
            <div className="mb-6">
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-3">
                    <div className="flex flex-wrap gap-2 justify-between flex-1">
                        {['F', 'D', 'D+', 'C', 'C+', 'B', 'B+', 'A', 'A+', 'حذف'].map((grade) => {
                            const selected = finalGrade === grade && !studyStatus;
                            const bg = grade === 'حذف'
                                ? (isDeleteClicked && !studyStatus ? 'rgba(227, 40, 90, 0.5)' : '#D5D2D2')
                                : (selected ? 'radial-gradient(43.64% 77.08% at 50% -10.42%, rgba(40, 227, 218, 0.5) 0%, rgba(40, 227, 218, 0.25) 100%)' : '#D5D2D2');
                            return (
                                <button key={grade} type="button" disabled={studyStatus}
                                    onClick={() => grade === 'حذف' ? handleDeleteClick() : handleFinalGradeSelection(grade)}
                                    className="flex items-center justify-center transition-all duration-200 disabled:opacity-60"
                                    style={{
                                        flex: '1 1 0%', minWidth: '60px', height: '28px', borderRadius: '12px',
                                        background: bg, color: '#081423',
                                        border: selected ? '0.5px solid rgba(40, 227, 218, 0.25)' : 'none'
                                    }}
                                >
                                    {grade}
                                </button>
                            );
                        })}
                    </div>
                </div>
            </div>

            <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-end gap-3">
                <div className="flex items-center justify-center md:justify-end gap-3">
                    <div onClick={handleStudyStatusToggle} className="relative cursor-pointer" style={{ width: '48px', height: '24px' }}>
                        <div className="absolute inset-0 rounded-full" style={{ background: studyStatus ? '#2A9E8D' : '#D5D2D2' }} />
                        <div className={`absolute w-5 h-5 rounded-full shadow-md transition-all duration-200 ${studyStatus ? 'translate-x-6' : 'left-0.5'}`} style={{ top: '2px', background: '#0f1e2e' }} />
                    </div>
                    <span className="text-white font-medium text-base">قيد الدراسة</span>
                </div>
            </div>

            <div className="mb-6">
                <div className="text-right mb-3"><h4 className="text-white font-medium text-base">المادة</h4><p className="text-gray-400 text-sm">(اختياري)</p></div>
                <input type="text" value={subject} onChange={(e) => setSubject(e.target.value)} placeholder="أدخل اسم المادة" className="w-full p-3 bg-[#1a2a3a] border border-[#28e3da40] rounded-lg text-white text-right" dir="rtl" />
            </div>

            <div className="mb-6">
                <div className="text-right mb-3"><h4 className="text-white font-medium text-base">تعليق محاضر</h4><p className="text-gray-400 text-sm">(اختياري)</p></div>
                <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="اكتب تعليقك هنا..." rows={6} maxLength={500} className="w-full p-3 bg-[#1a2a3a] border border-[#28e3da40] rounded-lg text-white text-right resize-none" dir="rtl" />
                <p className="text-gray-400 text-sm text-right mt-2">الباقي: {500 - comment.length}</p>
            </div>
        </div>
    );
  };

  if (!isOpen) return null;

  return createPortal(
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4" onClick={!submitting ? handleBackdropClick : undefined}>
      <div className={`absolute inset-0 bg-black bg-opacity-50 backdrop-blur-sm ${submitting ? 'cursor-wait' : ''}`}></div>
      <div className="relative bg-[#0f1e2e] rounded-2xl p-6 md:p-8 w-full max-w-6xl max-h-[90vh] overflow-y-auto" dir="ltr" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} disabled={submitting} className="absolute top-4 right-4 w-10 h-10 bg-[#1a2a3a] rounded-lg flex items-center justify-center text-white hover:bg-[#2a3a4a] transition-colors z-10 disabled:opacity-60">✕</button>

        <div className="text-center mb-8">
            <div className="flex justify-center mb-6">
                <div className="flex items-center gap-[5.93px]">
                    {(type === 'course' ? [2, 3] : [1, 2, 3]).map((step) => (
                        <div key={step} className={`transition-all duration-300 ${step <= currentStep ? 'bg-[#5FCC9C]' : 'bg-[#E9E9E9]'}`} style={{ width: '44.49px', height: '22.25px', borderRadius: '4px' }}></div>
                    ))}
                </div>
            </div>
            <h2 className="text-gray-400">{type === 'course' ? 'أضف تقييمك للمقرر' : 'أضف تقييمك للمحاضر'}</h2>
        </div>

        <div className="text-right mb-6">
            <p className="text-gray-300 text-sm leading-relaxed">
            {type === 'course'
                ? 'المقصود بالتقييم هو تقييم المقرر على المستوى التجربة الأكاديمية و التعليمية في الجامعة و لا نعني تقييم المحتوى بذاته'
                : 'المقصود بالتقييم هو تقييم المحاضر/ة على المستوى التجربة الأكاديمية و التعليمية في الجامعة و لا نعني تقييم الشخص بذاته'}
            </p>
        </div>

        <div className="mb-8">
            {type === 'lecturer' && currentStep === 1 && renderStep1()}
            {currentStep === 2 && renderStep2()}
            {currentStep === 3 && renderStep3()}
        </div>

        <div className="flex justify-center items-center pt-6 gap-4">
            {currentStep > (type === 'course' ? 2 : 1) && (
                <button onClick={handlePrevious} disabled={submitting || success} className="px-6 py-3 text-white font-bold rounded-xl border border-[#28e3da40] disabled:opacity-60" style={{ width: '122px', height: '42px' }}>السابق</button>
            )}

            {currentStep < 3 ? (
                <button onClick={handleNext} disabled={submitting || success} className="px-6 py-3 text-white font-bold rounded-xl bg-gradient-to-r from-[#28e3da80] to-[#28e3da40] disabled:opacity-60" style={{ width: '122px', height: '42px' }}>التالي</button>
            ) : (
                !success ? (
                    <button onClick={handleSubmit} disabled={submitting} className="px-6 py-3 text-white font-bold rounded-xl bg-gradient-to-r from-[#28e3da80] to-[#28e3da40] disabled:opacity-60" style={{ width: '122px', height: '42px' }}>
                        {submitting ? 'جارٍ الإرسال...' : 'إرسال'}
                    </button>
                ) : (
                    <span className="px-6 py-3 rounded-xl font-bold text-[#5FCC9C]">تم الإرسال ✅</span>
                )
            )}
        </div>
        {submitMsg && <p className={`text-sm mt-2 text-center ${submitMsg.includes('تم') ? 'text-[#5FCC9C]' : 'text-[#FA8686]'}`}>{submitMsg}</p>}
      </div>
    </div>,
    document.body
  );
};

export default EvaluationModal;
